import React from "react";
import { modules } from "../../mock/modules";

const actions = ["lihat", "tambah", "edit", "hapus"];

const AccessTable = ({ role, access = {}, onChange }) => {
  return (
    <div className="overflow-x-auto text-sm border border-gray-200 rounded-lg shadow">
      <table className="min-w-full bg-white">
        <thead className="text-white bg-green-700">
          <tr>
            <th className="px-4 py-2 text-left">Modul</th>
            {actions.map((action) => (
              <th key={action} className="px-4 py-2 capitalize">
                {action}
              </th>
            ))}
            <th className="px-4 py-2">Semua</th>
          </tr>
        </thead>
        <tbody>
          {modules
            .filter((modul) => modul !== "Manajemen Akses") // hanya ini ditambahkan
            .map((modul) => {
              const currentAccess = access?.[modul] || [];
              const allChecked = actions.every((act) =>
                currentAccess.includes(act)
              );

              return (
                <tr key={modul} className="border-t">
                  <td className="px-4 py-2 font-medium">{modul}</td>

                  {actions.map((action) => (
                    <td key={action} className="px-4 py-2 text-center">
                      <input
                        type="checkbox"
                        checked={currentAccess.includes(action)}
                        onChange={(e) =>
                          onChange(modul, action, e.target.checked)
                        }
                      />
                    </td>
                  ))}

                  <td className="px-4 py-2 text-center">
                    <input
                      type="checkbox"
                      checked={allChecked}
                      onChange={(e) => onChange(modul, "all", e.target.checked)}
                    />
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );
};

export default AccessTable;
